import elementUi from 'element-ui/lib/locale/lang/fr.js';

// Overwrites
elementUi.el.pagination.pagesize = ' / page';

export default elementUi;
